export const vocabStatusPage = {
    "404": [
        {
            title: "Página No Encontrada",
            message: "La página que buscas podría haber sido movida, eliminada o nunca existió.",
            btn: "Volver al Inicio"
        },
        {
            title: "Page Not Found",
            message: "The page you are looking for might have been moved, deleted, or never existed.",
            btn: "Return Home"
        }
    ],
    "403": [
        {
            title: "Acceso Denegado",
            message: "No tienes los permisos necesarios para acceder a esta área.",
            btn: "Volver al Inicio"
        },
        {
            title: "Access Denied",
            message: "You do not have the necessary permissions to access this area.",
            btn: "Return Home"
        }
    ],
    "500": [
        {
            title: "Error del Servidor",
            message: "Nuestros servidores están teniendo un problema. Por favor, inténtalo de nuevo más tarde.",
            btn: "Reintentar"
        },
        {
            title: "Server Error",
            message: "Our servers are having a moment. Please try again in a few minutes.",
            btn: "Retry"
        }
    ],
    "default": [
        {
            title: "Algo Salió Mal",
            message: "Ocurrió un error inesperado.",
            btn: "Volver al Inicio"
        },
        {
            title: "Something Went Wrong",
            message: "An unexpected error occurred.",
            btn: "Return Home"
        }
    ]
};